import { SentryService, SentryEnvironment } from '@travelata-libs/utils';
import Cookies from 'js-cookie';

declare const SENTRY_DSN: string;
declare const SENTRY_ENVIRONMENT: SentryEnvironment;
declare const SENTRY_RELEASE: string;

//доля трассируемых запросов (только 10% трассировок логируется в sentry) ошибки не смотрят на этот параметр и логируются все
const sentryService = new SentryService({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    userId: Cookies.get('clientUuid'),
    tracesSampleRate: 0.001, 
});

export default sentryService;
